import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReferenzenComponent} from './components/referenzen/referenzen.component';
import {SharedModule} from './shared.module';

@NgModule({
  declarations: [
    ReferenzenComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  bootstrap: [
    ReferenzenComponent,
  ]
})
export class ReferenzenModule {
  static components = {
    referenzen: ReferenzenComponent,
  };
}
